<template>
  <div :class="$style.base">
    <BaseHeading :sematic-level="2">
      Ups, da ist etwas schief gelaufen...
    </BaseHeading>
    <BaseText>
      Bitte lassen Sie diese Seite geöffnet. Wir starten eine erneute
      Aktualisierung.
    </BaseText>
    <RequestTimer v-bind="$attrs" />
    <img src="@/base/assets/illustrations/lost-connection.svg" rel="preload">
  </div>
</template>

<script setup lang="ts">
import RequestTimer from '../requestTimer/RequestTimer.vue'
import BaseHeading from '~/base/components/heading/Heading.vue'
import BaseText from '~/base/components/text/Text.vue'
</script>

<style module>
.base {
  z-index: 30;
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translateX(-50%);
  padding: 24px 9px;
  border-radius: 8px;
  background: var(--color-pacificblue);
  width: calc(100% - 24px);

  & * {
    color: var(--color-white);
    text-align: center;
  }

  & h2 {
    margin-bottom: var(--space-lg);
  }

  & p {
    margin-bottom: var(--space-sm);
    max-width: initial;

  }

  & img {
    width: clamp(200px, 40vw, 400px);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
}

/* TODO: check options for dynamic min width property */
@media screen and (min-width: 740px) {
  .base {
    width: calc(100% - 25%);
    padding: 40px;
    top: 20%;
    margin-bottom: var(--space-md);
  }
}
</style>
